import React, { useState, useEffect } from 'react';
import { useDelayedTickContext } from "../../context/DelayedTickContext";
import {useStateUpdatePermission} from "../../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../../contexts/QuoteContext";
import {getLastPrice, getQuote} from "@portfolio/utils/PFService";
import {useSharingContext} from "../../../contexts/SharingContext";
import {formatIndianValue} from "@portfolio/utils/formatNumber";

const CurrentValueDisplay = ({ instrumentToken,stock, contextName,shouldUseStockForDisplay  }) => {
    const [currentValue, setCurrentValue] = useState(null);
    const { canUpdateState } = useStateUpdatePermission(); // Access the permission state
    const delayedTickContext = useDelayedTickContext();
    const quoteContext = useQuoteContext();
    const { pfQuotes } =useSharingContext();
    const { showFormattedNumbers } = useSharingContext();

    const contextData = (() => {
        switch (contextName) {
            case 'DelayedTickContext':
                return delayedTickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const delayedTick = contextData.delayedTick;

    useEffect(() => {
        if (canUpdateState) {
            const currentValueLocal = (stock.currentValue);
            setCurrentValue(currentValueLocal.toFixed(2));
        }
    }, []);

    // Fetch and calculate price difference
    useEffect(() => {
        if (canUpdateState) {
            if (delayedTick.lastTradedPrice) {
                const currentValueLocal = (delayedTick.lastTradedPrice *stock.netQuantity);
                if (canUpdateState) {
                    setCurrentValue(currentValueLocal.toFixed(2));
                } // Limit to 2 decimal places
            }
        }
    }, [delayedTick.lastTradedPrice]);

    return (
        <div className="currentvalue-display">
           <span>
            {formatIndianValue(
                shouldUseStockForDisplay
                    ? stock.currentValue
                    : currentValue ?? stock.currentValue,
                showFormattedNumbers
            )}
        </span>


            {/*            <span>
                {shouldUseStockForDisplay
                    ? stock.currentValue?.toFixed(2)
                    : currentValue ?? stock.currentValue?.toFixed(2) ?? '0.00'}
            </span>*/}
        </div>
    );
};

export default CurrentValueDisplay;
